/**
 * PdfPreview — iframe que muestra un PDF Blob.
 *
 * Usa URL.createObjectURL para mostrar el blob inline; revoca la
 * URL en cleanup para evitar memory leak.
 */

import { useEffect, useState } from 'react'
import { Loader2 } from 'lucide-react'

interface Props {
  blob: Blob | null
  loading?: boolean
  error?: string | null
  height?: string | number
}

export function PdfPreview({ blob, loading, error, height = '70vh' }: Props) {
  const [url, setUrl] = useState<string | null>(null)

  useEffect(() => {
    if (!blob) {
      setUrl(null)
      return
    }
    const u = URL.createObjectURL(blob)
    setUrl(u)
    return () => URL.revokeObjectURL(u)
  }, [blob])

  return (
    <div
      style={{ height }}
      className="flex flex-col overflow-hidden rounded-md border border-border bg-bg-elevated"
    >
      {loading && (
        <div className="flex flex-1 items-center justify-center text-sm text-fg-muted">
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          Renderizando preview…
        </div>
      )}
      {!loading && error && (
        <div className="flex flex-1 items-center justify-center px-6 text-center text-sm text-red-600">
          {error}
        </div>
      )}
      {!loading && !error && !url && (
        <div className="flex flex-1 items-center justify-center text-sm text-fg-muted">
          Pulse "Generar preview" para ver el PDF.
        </div>
      )}
      {!loading && !error && url && (
        <iframe src={url} className="flex-1 border-0" title="PDF preview" />
      )}
    </div>
  )
}
